import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useMissingMappingTable } from "./hooks/useMissingMappingTable";

const headers = [
  { key: "remove", label: "", bodyClassName: "w-[40px] max-w-[40px] min-w-0 p-1" },
  { key: "lineItem", label: "Line Item", bodyClassName: "max-w-[300px]" },
  { key: "cat", label: "Category", bodyClassName: "!max-w-[100px] min-w-0" },
  { key: "variable", label: "Selector", bodyClassName: "!max-w-[100px] min-w-0" },
  { key: "activity", label: "Activity", bodyClassName: "!max-w-[100px] min-w-0" },
  { key: "unit", label: "Unit", bodyClassName: "!max-w-[100px] min-w-0 pr-2" },
];

export const MissingMappingTable = () => {
  const { missingMappings, renderItem } = useMissingMappingTable();

  return (
    <div className="flex h-full w-full flex-col rounded-lg bg-white">
      <div className="w-full overflow-x-auto">
        <Table className="w-full border-collapse">
          <TableHeader>
            <TableRow className="border-collapse border-[0.5px] border-[#eeeff1] bg-gray-100">
              {headers.map((header) => (
                <TableHead key={header.key} className="truncate px-6 !py-2 text-left text-xs font-medium text-[#71717A]">
                  {header.label}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody className="!border-[0.5px] border-[#eeeff1]">
            {!missingMappings?.length ? (
              <TableRow>
                <TableCell colSpan={headers.length} className="py-4 text-center text-gray-500">
                  No missing mappings
                </TableCell>
              </TableRow>
            ) : (
              missingMappings.map((row, rowIndex) => (
                <TableRow key={rowIndex} className="!border-collapse !border-b-1 border-[#eeeff1]">
                  {headers.map(({ key, bodyClassName }) => (
                    <TableCell key={key} className={`max-w-[150px] min-w-[150px] truncate px-6 !py-2 text-sm ${bodyClassName}`}>
                      {renderItem(key, row)}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
